module.exports = __webpack_public_path__ + "img/m-banner-ugevkzdv-de-DE.bf83b8c7.jpg";